
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger, DialogClose, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';
import { Bell, Send } from 'lucide-react';
import { saveContact } from '@/lib/supabaseClient';

const SignupForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Salvar no Supabase e enviar email
      const success = await saveContact(name, email, phone);
      
      if (success) {
        setIsSubmitted(true);
        toast({
          title: "Tudo certo!",
          description: "Você receberá um aviso especial sobre nossa inauguração!",
          duration: 5000,
        });
      }
    } catch (error) {
      console.error("Erro ao enviar formulário:", error);
      toast({
        title: "Ops, algo deu errado!",
        description: "Por favor, tente novamente mais tarde.",
        variant: "destructive",
        duration: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="bg-floresta-pistachio hover:bg-green-200 text-floresta-acaiDark font-bold text-lg md:text-xl py-6 px-8 rounded-full shadow-lg animate-pulse-soft transition-all duration-300 hover:shadow-xl">
          <Bell className="w-5 h-5 mr-2" />
          Quero ser avisado!
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md rounded-xl border-floresta-acai border-opacity-20">
        <DialogTitle className="text-2xl font-bold text-center text-floresta-acaiDark">
          {!isSubmitted ? "Fique por dentro!" : "🎉 Tudo certo!"}
        </DialogTitle>
        
        {!isSubmitted ? (
          <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div className="space-y-2">
              <Label htmlFor="name" className="text-floresta-acaiDark">Nome</Label>
              <Input 
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Seu nome"
                required
                className="rounded-md"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="email" className="text-floresta-acaiDark">Email</Label>
              <Input 
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu-email@exemplo.com"
                required
                className="rounded-md"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="phone" className="text-floresta-acaiDark">Telefone (Opcional)</Label>
              <Input 
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="(XX) XXXXX-XXXX"
                className="rounded-md"
              />
            </div>
            <DialogFooter className="mt-6 sm:justify-between">
              <DialogClose asChild>
                <Button type="button" variant="outline" className="text-floresta-acaiDark">
                  Cancelar
                </Button>
              </DialogClose>
              <Button 
                type="submit"
                className="bg-floresta-acai hover:bg-floresta-acaiDark text-white"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>Enviando...</>
                ) : (
                  <>
                    <Send className="w-4 h-4 mr-2" />
                    Enviar
                  </>
                )}
              </Button>
            </DialogFooter>
          </form>
        ) : (
          <div className="py-8 text-center space-y-4">
            <p className="text-lg">
              Você será um dos primeiros a saber quando a Floresta Sorvetes & Açaí abrir as portas.
            </p>
            <p className="text-xl font-bold text-floresta-acaiDark">
              Prepare-se para um brinde delicioso 🍦✨
            </p>
            <DialogClose asChild>
              <Button className="mt-4 bg-floresta-acai hover:bg-floresta-acaiDark text-white">
                Fechar
              </Button>
            </DialogClose>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SignupForm;
